var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalInvoices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 84,
    viewBox: "0 0 204 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 84,
    rx: 8,
    fill: "#28a745"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M196 84C200.418 84 204 80.4183 204 76V38.8259C204 31.7688 195.528 28.1685 190.447 33.0667L186.748 36.6331C185.89 37.4606 184.858 38.0857 183.727 38.4629L170.779 42.7819C168.696 43.4765 166.42 43.2849 164.483 42.2518L153.08 36.1706C149.869 34.4581 145.907 35.1286 143.438 37.8023L134.04 47.9803C131.722 50.49 128.067 51.2514 124.94 49.8757L116.659 46.2322C113.49 44.8375 109.782 45.6408 107.474 48.2224L97.6966 59.1574C94.8753 62.3127 90.0843 62.7243 86.7661 60.0965L77.5162 52.771C75.7243 51.3519 73.411 50.7671 71.16 51.1641L57.9159 53.5C56.4816 53.753 55.1436 54.3927 54.0461 55.3502L41.028 66.708C38.8346 68.6218 35.7746 69.193 33.0384 68.1995L22.5318 64.3848C20.4337 63.623 18.1127 63.7724 16.1296 64.797L3.65497 71.2418C1.41005 72.4016 0 74.7172 0 77.2441C0 80.9753 3.02474 84 6.75594 84H196Z",
    fill: "url(#paint0_linear_2248_47)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28a745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E72B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalInvoices);
export default __webpack_public_path__ + "static/media/TotalInvoices.4e51225cbe178f7d15e1e80a5e2cac6e.svg";
export { ForwardRef as ReactComponent };